import { buildScopedI18n } from '../../utils/buildScopedI18n';
import confirmModalEsCL from './locales/es-CL.json';
import confirmModalEnUS from './locales/en-US.json';
import confirmModalPtBR from './locales/pt-BR.json';

export const confirmModalI18n = buildScopedI18n({
  esCL: confirmModalEsCL,
  enUS: confirmModalEnUS,
  ptBR: confirmModalPtBR,
});
